import React from 'react';
import PropTypes from 'prop-types';

import {Typography, Box, Stack} from 'views/components';
import {AccessTime as AccessTimeIcon, KeyboardDoubleArrowDown as KeyboardDoubleArrowDownIcon} from 'views/icons';
import {translate} from 'views/module';

import getStylesByStatus from './getStylesByStatus';

import moment from 'moment';

const EventTile = (props) => {
  const {event} = props.event;
  const {tileData} = props;
  const {continuesPrior} = tileData;

  const startTimeMoment = moment(event.eventData.startTime);
  const endTimeMoment = moment(event.eventData.endTime);
  const startTime = startTimeMoment.format('hh:mmA');

  const durationMinutes = endTimeMoment.diff(startTimeMoment, 'minutes');
  const isVeryShortEvent = durationMinutes <= 40;
  const isShortEvent = durationMinutes <= 60;

  const hasShiftConfirmation = !!event.caregiverUpdates.find((e) => e.type === 'shiftConfirmation');
  const hasClockInConfirmation = !!event.caregiverUpdates.find((e) => e.type === 'clockInConfirmation');
  const hasClockOutConfirmationn = !!event.caregiverUpdates.find((e) => e.type === 'clockOutConfirmation');
  const hasRequestedReschedule = !!event.caregiverUpdates.find((e) => e.type === 'requestReschedule');
  const hasRequestedCancel = !!event.caregiverUpdates.find((e) => e.type === 'requestCancel');

  let status = 'unconfirmed';

  if (hasRequestedCancel) {
    status = 'requestCancel';
  } else if (hasRequestedReschedule) {
    status = 'requestReschedule';
  } else if (hasClockOutConfirmationn) {
    status = 'clockOutConfirmation';
  } else if (hasClockInConfirmation) {
    status = 'clockInConfirmation';
  } else if (hasShiftConfirmation) {
    status = 'shiftConfirmation';
  }

  const styles = getStylesByStatus(status);

  return (
    <Box
      sx={{
        background: styles.background,
        p: isVeryShortEvent ? 0.25 : 0.75,
        pb: isVeryShortEvent ? 0.1 : 0.5,
        borderLeft: `3px solid ${styles.borderColor}`,
        cursor: 'pointer',
        width: '100%',
        height: '100%',
        flexDirection: 'column',
      }}
    >
      {
        continuesPrior &&
        <KeyboardDoubleArrowDownIcon
          sx={{
            opacity: 0.7,
            color: styles.borderColor,
            display: 'flex',
            alignItems: 'center',
            mb: 1,
            width: '100%',
          }}
        />
      }
      <Typography
        variant="caption"
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: 'block',
          fontWeight: 'medium',
          color: styles.textColor,
          fontSize: isVeryShortEvent ? '0.7rem' : '0.875rem',
          lineHeight: isVeryShortEvent ? 1 : 1.2,
        }}
      >
        {event.info.title}
      </Typography>
      {!isShortEvent && (
        <Stack
          direction='column'
          alignItems='flex-start'
          spacing={0.5}
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {
            continuesPrior &&
            <Stack
              direction={'row'}
              sx={{
                pt: 0.5,
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  opacity: 0.7,
                  color: styles.textColor,
                  display: 'flex',
                  alignItems: 'center',
                  fontWeight: 'medium',
                  lineHeight: 1,
                  whiteSpace: 'normal', // allows text to wrap
                  wordBreak: 'break-word', // breaks long words if needed
                }}
              >
                <AccessTimeIcon sx={{fontSize: '0.9rem', mr: 0.5}} />
                {translate('caregiver.CaregiverCalendar.Calendar.ContinuesFromDay')}
                {startTimeMoment.format('dddd')}
              </Typography>
            </Stack>
          }
          {
            !continuesPrior &&
            <Box>
              <Typography
                variant="caption"
                sx={{
                  opacity: 0.7,
                  color: styles.textColor,
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <AccessTimeIcon sx={{fontSize: '0.9rem', mr: 0.5}} />
                {startTime}
              </Typography>
            </Box>
          }
          {
            styles.label && (
              <Box
                sx={{
                  border: `1px solid ${styles.borderColor}`,
                  borderRadius: 1,
                  alignItems: 'center',
                  height: 'fit-content',
                  px: 0.5,
                  py: 0.1,
                  display: 'flex',
                  lineHeight: 1,
                }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    fontWeight: 'medium',
                    color: styles.textColor,
                    lineHeight: 1,
                  }}
                >
                  {styles.label}
                </Typography>
              </Box>
            )
          }
        </Stack>
      )}
    </Box>
  );
};

EventTile.propTypes = {
  event: PropTypes.object.isRequired,
  tileData: PropTypes.any,
};

export default EventTile;
